import { useMemo } from 'react';
import { useServiceCategories } from '../services/serviceCategoryService';

/**
 * Hook to fetch and parse service categories for the home page
 * @returns {object} - { categories, isLoading, error }
 */
export const useHomeCategories = () => {
  const { data: categoriesResponse, isLoading, error } = useServiceCategories({
    active: true,
    sort_by: 'sort_order',
    sort_order: 'asc',
    per_page: 50
  });

  const categories = useMemo(() => {
    if (!categoriesResponse) return [];
    
    // Handle different response structures
    let categoriesData = [];
    if (categoriesResponse?.success !== false) {
      categoriesData = categoriesResponse?.data?.data || 
                       categoriesResponse?.data || 
                       categoriesResponse || 
                       [];
    }
    
    return Array.isArray(categoriesData) ? categoriesData : [];
  }, [categoriesResponse]);

  return {
    categories,
    isLoading,
    error
  };
};

